import React, { useEffect, useRef, useState } from 'react';
import { Badge, Box, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Cancel, MusicNote } from '@mui/icons-material';
import { useRecoilState } from 'recoil';

import { sharedAudiosState } from './../../common/recoil/Share/atom';
import { CHAT_EVENTS } from './../../common/constants';
import { useChat } from './../../common/hooks';

const useStyles = makeStyles((theme) => ({
	button: {
		// position: 'absolute',
		// right: 0,
		// zIndex: 100000,
		margin: 0,
		padding: 0,
	},
	musicArea: {
		position: 'fixed',
		width: '300px',
		zIndex: 100000,
	},
	musicElement: {
		display: 'flex',
	},
	audio: {
		width: '350px',
	},
}));

const AudioTooltip = () => {
	const classes = useStyles();
	const [sharedAudios, setSharedAudios] = useRecoilState(sharedAudiosState);
	const [open, setOpen] = useState(false);
	const audioElementsRef = useRef({});
	const previousAudioIdsRef = useRef([]);
	const { sendMessage } = useChat();

	useEffect(() => {
		if (sharedAudios?.length > 0) {
			setOpen(true);
		}

		const previousAudioIds = previousAudioIdsRef.current;
		sharedAudios?.forEach((audio) => {
			const audioElement = audioElementsRef.current[audio.id];
			if (!audioElement) {
				return;
			}

			audioElement.volume = 0.2;
			if (!previousAudioIds.includes(audio.id)) {
				audioElement.currentTime = 0;
			}
			audioElement.play().catch((error) => {
				console.log('error playing shared audio', error);
			});
		});

		previousAudioIdsRef.current = sharedAudios?.map((audio) => audio.id) || [];
	}, [sharedAudios]);

	const handleClick = (event) => {
		setOpen(!open);
	};

	const handlePlay = (event, other) => {};
	const handlePause = (event, other) => {};
	const ended = (event, other) => {};

	const removeMusic = (id) => {
		const audioElement = audioElementsRef.current[id];
		if (audioElement) {
			audioElement.pause();
			audioElement.currentTime = 0;
			delete audioElementsRef.current[id];
		}

		const tempAudios = [...sharedAudios?.filter((x) => x.id !== id)];
		setSharedAudios(tempAudios);

		const shareImgMessage = {
			type: CHAT_EVENTS.SHARE_S3_AUDIO,
			sharedAudio: tempAudios,
		};
		sendMessage(shareImgMessage);
	};

	return (
        <Box>
			<IconButton
                className={classes.button}
                aria-describedby="shareMusic"
                type="button"
                disabled={sharedAudios?.length === 0}
                onClick={handleClick}
                size="large">
				<Badge badgeContent={sharedAudios?.length || 0} color="error">
					<MusicNote></MusicNote>
				</Badge>
			</IconButton>
			<Box className={classes.musicArea} visibility={open ? 'visible' : 'hidden'}>
				{sharedAudios?.map((audio) => {
					return (
                        <Box key={audio.id} className={classes.musicElement}>
							<audio
								id={audio.id}
								ref={(element) => {
									if (element) {
										audioElementsRef.current[audio.id] = element;
									} else {
										delete audioElementsRef.current[audio.id];
									}
								}}
								loop={true}
								controls
								autoPlay
								preload="auto"
								onPlay={handlePlay}
								onPause={handlePause}
								onEnded={ended}
								className={classes.audio}>
								<source src={audio.url} type={audio.mime}></source>
							</audio>
							<IconButton color="secondary" size="large">
								<Cancel
									onClick={() => {
										removeMusic(audio.id);
									}}></Cancel>
							</IconButton>
						</Box>
                    );
				})}
			</Box>
		</Box>
    );
};

export default AudioTooltip;
